/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Retention_TitleInputs */

const en_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Data Retention`)
};

const de_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Datenspeicherung`)
};

const fr_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Conservation des données`)
};

const es_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Retención de datos`)
};

const it_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Conservazione dei dati`)
};

const nl_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Gegevensbewaring`)
};

const pl_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Przechowywanie danych`)
};

const fi_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Tietojen säilytys`)
};

const da_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Dataopbevaring`)
};

const sv_privacy_data_retention_title = /** @type {(inputs: Privacy_Data_Retention_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Datalagring`)
};

/**
* | output |
* | --- |
* | "5. Data Retention" |
*
* @param {Privacy_Data_Retention_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_retention_title = /** @type {((inputs?: Privacy_Data_Retention_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Retention_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_retention_title(inputs)
	if (locale === "fr") return fr_privacy_data_retention_title(inputs)
	if (locale === "es") return es_privacy_data_retention_title(inputs)
	if (locale === "it") return it_privacy_data_retention_title(inputs)
	if (locale === "nl") return nl_privacy_data_retention_title(inputs)
	if (locale === "pl") return pl_privacy_data_retention_title(inputs)
	if (locale === "fi") return fi_privacy_data_retention_title(inputs)
	if (locale === "da") return da_privacy_data_retention_title(inputs)
	if (locale === "sv") return sv_privacy_data_retention_title(inputs)
	return en_privacy_data_retention_title(inputs)
});